export default __webpack_public_path__ + "static/dots-99b1068d89f48adbca5b88bd36fa94e5.svg";